import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { motion } from 'framer-motion';
import { AnimationSuccess } from 'shared';
import imgPhoneBG from 'images/smartphone-bg.png';
import imgPhone from 'images/smartphone.png';
/**
 * @name AnimationPhoneWait
 */
export default function AnimationPhoneSuccess() {
    return (_jsxs("div", { className: "check-phone-image", children: [_jsx("div", { className: "phone-image", children: _jsx(motion.div, { initial: {
                        opacity: 0,
                        scale: 0.5,
                    }, animate: {
                        opacity: 1,
                        scale: 1,
                    }, transition: {
                        delay: 0.25,
                        duration: 0.5,
                    }, className: "animate-check-phone-image", children: _jsx("img", { src: imgPhone, alt: "phone" }) }) }), _jsx("div", { className: "phone-animation", children: _jsx(AnimationSuccess, { color: "#434AA0", width: "30px", height: "55px", margin: "0 auto", minHeight: "55px", maxHeight: "150px", top: "-24px", left: "8px" }) }), _jsx("div", { className: "phone-bg", children: _jsx("img", { src: imgPhoneBG, alt: "phone" }) })] }));
}
